import { Grid, Typography } from "@mui/material";

export function FinanceView(props) {
  return (
    <>
      <Grid
        container
        justifyContent="space-between"
        marginTop="10px"
        item
        lg={12}
      >
        <Typography
          sx={{
            fontWeight: "600",
            fontSize: "16px",
            color: "#4c5a6a",
            marginBottom: "30px",
            paddingBottom: "20px",
            paddingTop: "20px",
          }}
        >
          Finance
        </Typography>
      </Grid>
      <Grid container lg={12} marginTop={"30px"}>
        <Typography>Agreements</Typography>
        <Grid
          container
          lg={12} // justifyContent={"space-between"}
        >
          <Grid container item lg={6} justifyContent="space-around">
            <Grid container item lg={12}>
              <Grid item>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#4c5a6a",
                    paddingBottom: "7px",
                    paddingTop: "10px",
                  }}
                >
                  Agreement Expiry
                </Typography>
                <Typography fontWeight={600}>
                  {props.details?.doctorFinance?.agreementExpiryFrom
                    ?.split("T")[0]
                    ?.replaceAll("-", "/") || "N/A"}
                </Typography>
              </Grid>
              <Grid
                lg={2}
                container
                height={props.isEditable ? 150 : 100}
                alignItems={"center"}
                justifyContent={"center"}
                marginBottom={"15px"}
              >
                <Typography>To</Typography>
              </Grid>
              <Grid item>
                <Typography
                  sx={{
                    fontWeight: "600",
                    fontSize: "14px",
                    color: "#f9fbfc",
                    paddingBottom: "7px",
                    paddingTop: "10px",
                  }}
                >
                  {" "}
                  Agreement End
                </Typography>
                <Typography fontWeight={600}>
                  {props.details?.doctorFinance?.agreementExpiryTo
                    ?.split("T")[0]
                    ?.replaceAll("-", "/") || "N/A"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
